export interface UserConversationEntity {
  isShipper: boolean;
  isDirectMessage: boolean;
  entityId: string;
  entityName: string;
}
